import { useState } from "react";
import { useLocation, useNavigate } from "react-router";
import appApi from "../../utils/AppApi";
import toast from "react-hot-toast";
import errorHandler from "../../utils/ErrorHandler";
import { useDispatch } from "react-redux";
import {
  setCurrentUser,
  setAuthToken,
  setShowOtp,
  setLoadingLogout,
} from "../../redux/actions/User";

export default function useLoginActions() {
  const [loading, setLoading] = useState(false);
  //   login States
  const [loginNationalCode, setloginNationalCode] = useState("");
  const [loginPassWord, setLoginPassWord] = useState("");
  // enroll States
  const [personalCode, setpersonalCode] = useState("");
  const [relation, setRelation] = useState("کارمند فولاد");
  const [name, setName] = useState("");
  const [enrollNationalCode, setenrollNationalCode] = useState("");
  const [phoneNumner, setPhoneNumner] = useState("");
  const [enrollpassword, setEnrollpassword] = useState("");
  const [repeatEnrollpassword, setrepeatEnrollpassword] = useState("");

  let navigate = useNavigate();
  let location = useLocation();

  const dispatch = useDispatch();

  let from = location.state?.from?.pathname || "/profile";

  const otpRequest = async () => {
    try {
      await appApi
        .post("/user/otprequest", {
          nationalCode: loginNationalCode,
        })
        .then(({ data }) => {
          dispatch(setCurrentUser(data.user));
          dispatch(setShowOtp(true));
        });
    } catch (error) {
      errorHandler(error);
    }
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    localStorage.removeItem("Ticket");
    if (!loginNationalCode || !loginPassWord) {
      toast.error("وارد کردن تمامی موارد الزامی است");
    } else {
      setLoading(true);
      try {
        await appApi
          .post("/user/login", {
            nationalCode: loginNationalCode,
            password: loginPassWord,
          })
          .then(({ data }) => {
            dispatch(setCurrentUser(data.user));
            dispatch(setAuthToken(data.token));
            localStorage.setItem("UserToken", data.token);
            localStorage.setItem("currentUser", data.user.id);
            setloginNationalCode("");
            setLoginPassWord("");
            setLoading(false);
            toast.success("با موفقیت به «راه بهشت» وارد شدید");
            navigate(from, { replace: true });
          });
      } catch (error) {
        setLoading(false);
        if (error.response) {
          if (error.response.data.msg === "User is not active") {
            otpRequest();
          } else {
            toast.error(error.response.data.msgFa);
          }
        }
      }
    }
  };

  const handleLogout = async () => {
    localStorage.removeItem("Ticket");
    dispatch(setLoadingLogout(true));
    setTimeout(() => {
      localStorage.removeItem("UserToken");
      localStorage.removeItem("currentUser");
      dispatch(setAuthToken(""));
      dispatch(setCurrentUser(null));
      delete appApi.defaults.headers.common["Authorization"];
      dispatch(setLoadingLogout(false));
    }, 1500);
  };

  const handleForgetPass = () => {
    navigate("/forgetPass", { replace: true });
  };

  const handleEnroll = async (e) => {
    e.preventDefault();
    localStorage.removeItem("Ticket");
    if (
      !personalCode ||
      !name ||
      !enrollNationalCode ||
      !phoneNumner ||
      !enrollpassword ||
      !repeatEnrollpassword
    ) {
      toast.error("وارد کردن تمامی موارد الزامی است");
    } else {
      if (enrollpassword !== repeatEnrollpassword) {
        toast.error("رمزعبور و تکرار آن باید یکسان باشد!");
      } else {
        try {
          setLoading(true);
          await appApi
            .post("/user/register", {
              personnelCode: personalCode,
              relation: relation,
              fullName: name,
              nationalCode: enrollNationalCode,
              phone: phoneNumner,
              password: enrollpassword,
            })
            .then(({ data }) => {
              dispatch(setCurrentUser(data.user));
              dispatch(setAuthToken(data.token));
              localStorage.setItem("UserToken", data.token);
              localStorage.setItem("currentUser", data.user.id);
              setLoading(false);
              setpersonalCode("");
              setName("");
              setenrollNationalCode("");
              setPhoneNumner("");
              setPhoneNumner("");
              setEnrollpassword("");
              dispatch(setShowOtp(true));
            });
        } catch (error) {
          setLoading(false);
          errorHandler(error);
        }
      }
    }
  };

  return {
    loading,
    setLoading,
    loginNationalCode,
    setloginNationalCode,
    loginPassWord,
    setLoginPassWord,
    personalCode,
    setpersonalCode,
    relation,
    setRelation,
    name,
    setName,
    enrollNationalCode,
    setenrollNationalCode,
    phoneNumner,
    setPhoneNumner,
    enrollpassword,
    setEnrollpassword,
    repeatEnrollpassword,
    setrepeatEnrollpassword,
    handleLogin,
    handleEnroll,
    handleLogout,
    handleForgetPass,
  };
}
